function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useSignal } from "@preact/signals-react";
export var TextNodeBloc = /*#__PURE__*/function () {
  function TextNodeBloc(props) {
    var _props$textAreaValue, _props$isInBlueprint;
    _classCallCheck(this, TextNodeBloc);
    _defineProperty(this, "placeHolder", useSignal("Enter input"));
    _defineProperty(this, "textValue", useSignal(""));
    _defineProperty(this, "isInBlueprint", useSignal(false));
    this.props = props;
    this.textValue.value = ((_props$textAreaValue = props.textAreaValue) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue[0]) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue.results) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue[0]) === null || _props$textAreaValue === void 0 ? void 0 : _props$textAreaValue.content) || "";
    this.isInBlueprint.value = (_props$isInBlueprint = props.isInBlueprint) !== null && _props$isInBlueprint !== void 0 ? _props$isInBlueprint : false;
    if (props.placeholder) {
      this.placeHolder.value = props.placeholder;
    } else {
      if (props.parentNodeId) {
        this.placeHolder.value = "Output shown here";
      } else {
        this.placeHolder.value = "Enter input";
      }
    }
  }
  _createClass(TextNodeBloc, [{
    key: "reSizeStyle",
    value: function reSizeStyle() {
      var reSizeStyle = {
        width: undefined,
        height: undefined
      };
      reSizeStyle.width = "100%";
      if (this.props.resizeEventParams && this.props.resizeEventParams.width) {
        reSizeStyle.width = this.props.resizeEventParams.width - 20;
      }
      if (this.props.resizeEventParams && this.props.resizeEventParams.height) {
        reSizeStyle.height = this.props.resizeEventParams.height - 42 - (this.props.enableFeedback ? 40 : 0);
      } else {
        reSizeStyle.height = undefined;
      }
      return reSizeStyle;
    }
  }]);
  return TextNodeBloc;
}();